// ============================================================
// documents/pdf.js
// ------------------------------------------------------------
// ตั้งค่า pdfmake + ฟอนต์ไทย และตัวเปิด/พิมพ์ไฟล์ PDF
// เดิมโค้ดชุดนี้ copy อยู่ในตัวสร้างรายงานทั้ง 13 ไฟล์
//
// ฟอนต์มาจาก assets/font/vfs_fonts.js (fork ที่ฝังฟอนต์ไทยไว้แล้ว)
// ============================================================

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import { alert } from "../shared/index.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  FCIconic: { normal: "FCIconic-Light.ttf", bold: "FCIconic-Bold.ttf", italics: "FCIconic-Italic.ttf", bolditalics: "FCIconic-Italic.ttf" },
  THSarabunNew: { normal: "THSarabunNew.ttf", bold: "THSarabunNew-Bold.ttf", italics: "THSarabunNew-Italic.ttf", bolditalics: "THSarabunNew-BoldItalic.ttf" },
  Roboto: { normal: "Roboto-Regular.ttf", bold: "Roboto-Medium.ttf", italics: "Roboto-Italic.ttf", bolditalics: "Roboto-MediumItalic.ttf" },
};

// สั่งพิมพ์ทันที (ไม่เปิดหน้าต่างพรีวิว)
export async function printPdf(docDefinition) {
  pdfMake.createPdf(docDefinition).print();
}

// เปิดไฟล์ PDF ในแท็บใหม่
// เบราว์เซอร์บางตัวบล็อกการเปิดแท็บ — กรณีนั้นให้ดาวน์โหลดแทนแล้วแจ้งผู้ใช้
export async function openPdf(docDefinition, filename = "ทดสอบ") {
  try {
    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    pdfMake.createPdf(docDefinition).download(filename);
    if (error === "Open PDF in new window blocked by browser") {
      alert("warning", "แจ้งเตือน", "ไม่สามารถเปิดเอกสารได้เนื่องจากการปิดกั้นจากบราวเซอร์");
    } else {
      alert("warning", "แจ้งเตือน", "กรุณาลองใหม่อีกครั้ง");
    }
  }
}

export default pdfMake;
